const nonceMetaTag = document.querySelector('meta[name="csp-nonce"]');

export const cspNonce = nonceMetaTag?.getAttribute('content') || '';

if (cspNonce) {
    __webpack_nonce__ = cspNonce;
}
